import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class ContactService {
  async getAll (queryData) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/web/contact`,
        { headers: token, params: { ...queryData } }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async getContactInformation (id) {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/web/contact/${id}`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteContact (rowClicked) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/web/contact/${rowClicked.id}`,
        { headers: token }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async deleteContactLpgd (id, data) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/web/lgpd/contact/${id}`,
        { headers: token, params: { ...data } }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async updateContact (id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/web/contact/${id}`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async updateArrayContact (data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/web/arrayupdate/contact`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}

export default new ContactService()
